import { render } from "./WpEditor.vue?vue&type=template&id=355cb4d7&scoped=true"
import script from "./WpEditor.vue?vue&type=script&lang=js"
export * from "./WpEditor.vue?vue&type=script&lang=js"

import "./WpEditor.vue?vue&type=style&index=0&id=355cb4d7&lang=scss&scoped=true"

import exportComponent from "/Users/niteshdas/Projects/wordpress/wp-content/plugins/easy-restaurant-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355cb4d7"]])

export default __exports__